export interface FaqItem {
  question: string
  answer: string
}

export const faqItems: FaqItem[] = [
  {
    question: 'What materials does Shear Geometry cover?',
    answer:
      'The legacy published guidance covers 6061-T6 aluminum, copper and soft aluminum alloys, plus titanium with DR80 inserts. Contact Robertson Precision to confirm that a current product fits a specific alloy and application.',
  },
  {
    question: 'Can I use these tools on a manual lathe?',
    answer:
      'No. The published instructions specify CNC lathes only and say the tooling is not intended for manual lathes.',
  },
  {
    question: 'Which holder sizes are published?',
    answer:
      'The published system includes the 1-inch SALXR 16-3D and 3/4-inch SALXR 12-3B holders.',
  },
  {
    question: 'What comes in a starter kit?',
    answer:
      'The published 1-inch and 3/4-inch kits each include the matching holder, 10 APGX 331R inserts, a T-15 Torx driver and extra screws. Confirm current kit contents and availability with sales.',
  },
  {
    question: 'How are inserts packaged?',
    answer:
      'The legacy published catalog says inserts were sold in full boxes of 10. Confirm current packaging, stock and price directly before ordering.',
  },
  {
    question: 'When should I consider a chipbreaker insert?',
    answer:
      'The published -30R chipbreaker range uses a lower feed starting range than the roughing insert and is intended for applications where tighter chip control is the priority. Final selection depends on the material and setup.',
  },
  {
    question: 'What information should I send for product guidance?',
    answer:
      'Send the material and condition, machine model and horsepower, workholding, holder size, target depth of cut and feed, application goal, and expected quantity.',
  },
  {
    question: 'How do I confirm current availability?',
    answer:
      'Call 800-397-7745 or email sales@sheargeometry.com. Current stock, pricing, lead time and dealer status are confirmed directly.',
  },
]
